import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { ISiteData } from 'tag/ts/tag/interfaces/api/ISiteData';
import { ISiteSessionData } from 'tag/ts/tag/interfaces/api/ISiteSessionData';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { ISiteUtilities } from 'tag/ts/tag/interfaces/utilities/ISiteUtilities';
import { TagAction } from 'tag/ts/tag/model/enums/TagAction';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Site related utilities
 */
export class SiteUtilities extends AbstractTagClass implements ISiteUtilities {
	// Site session data stored after execution of getSiteSessionData method
	#siteSessionData: ISiteSessionData;

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'SiteUtilities'
			}
		);
	}

	/**
	 * @description Returns stored site session data
	 * @returns {ISiteSessionData}
	 */
	get siteSessionData(): ISiteSessionData {
		return this.#siteSessionData;
	}

	/**
	 * @description Gets and returns site session data
	 * @param {string} target - class or method name where this call executed from
	 * @returns {Promise<ISiteSessionData>}
	 */
	getSiteSessionData = ( target: string = undefined ): Promise<ISiteSessionData> => {
		return new Promise(
			( resolve ) => {
				// request session data from page
				const sessionData: Promise<ISiteData | any> = this.TAG_API.tagAction(
					{
						action: TagAction.GET_SESSION_DATA,
						uuid: this.uuid
					},
					true
				);

				if ( this.utils.Type.isPromise( sessionData ) ) {
					sessionData.then(
						( data: ISiteData ) => {
							this?.logger?.log(
								'getSiteSessionData:',
								'target:',
								target,
								'Page session data received:',
								data.sessionData
							);
							this.#siteSessionData = data.sessionData; // store site session data for later use
							resolve( data.sessionData ); // resolve promise
						}
					).catch(
						( error ) => {
							this?.logger?.log(
								'getSiteSessionData:',
								'target:',
								target,
								'Page session data ERROR:',
								error,
								'Continue without session data.'
							);
							this.#siteSessionData = undefined;
							resolve( undefined );
						}
					);
				} else {
					// promise was not returned
					this?.logger?.log(
						'getSiteSessionData:',
						'target:',
						target,
						'Page did not return promise. Check if method exists in DOM.',
						'Continue without page session data.'
					);
					this.#siteSessionData = undefined;
					resolve( undefined );
				}
			}
		);
	};
}